import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";

import Navbar from "../../Components/Navbar";
import { Colors } from "../../Constant/Color";

import {
  Autocomplete,
  Box,
  Button,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Snackbar,
  Alert,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  
} from "@mui/material";

import {
  Add,
  Close,
  Delete,
  Edit,
  FilterAlt,
  Refresh,
  Search,
    ReceiptLong,
  LocalOffer,
  Try,
} from "@mui/icons-material";
import { Base_Uri } from "../../Constant/BaseUri";
import { useDispatch, useSelector } from "react-redux";
import SearchableCreatableDropdown from "../../Components/SearchableCreatableDropdown";
import JsBarcode from "jsbarcode";
import moment from "moment/moment";
import ProductManager from "../../Components/ProductManager";
import FaultyManager from "./FaultyManager.js";
import FaultyReportDialog from "./FaultyReportDialog";
import useScanDetection from "use-scan-detection";
import { selectInvoicedCustomer, updateCart, UpdateJobDetails } from "../../Redux/LoginReduces.js";
import { useNavigate } from "react-router";


/*
  Change this URL according to your backend.

  Example:
  Base_Uri=http://localhost:5000/api
*/


const initialForm = {
  customerId: "",
  employeeId: "",
  phoneMake: "",
  phoneModel: "",
  imei: "",
  fault: "",
  advancedPrice: "",
  price: "",
  date: new Date().toISOString().split("T")[0],
  status: "Pending",
};

const initialFilters = {
  startDate: "",
  endDate: "",
  customerName: "",
  accountNo: "",
  imei: "",
  jobNo: "",
  status: "",
};

const repairStatuses = [
  "Pending",
  "Complete",
  // "Delivered",
  "Collected",
];

const paymentMethods = [
  {
    label: "Cash",
    value: "cash",
  },
  {
    label: "Card",
    value: "card",
  },
  {
    label: "Online",
    value: "online",
  },
  // {
  //   label: "On Account",
  //   value: "onaccount",
  // },
];

const getArrayFromResponse = (response) => {
  const responseData = response?.data;

  if (Array.isArray(responseData)) {
    return responseData;
  }

  if (Array.isArray(responseData?.data)) {
    return responseData.data;
  }

  if (Array.isArray(responseData?.customers)) {
    return responseData.customers;
  }

  if (Array.isArray(responseData?.employees)) {
    return responseData.employees;
  }

  if (Array.isArray(responseData?.result)) {
    return responseData.result;
  }

  return [];
};

const getEmployeeName = (employee) => {
  if (!employee) {
    return "";
  }

  if (employee.name) {
    return employee.name;
  }

  if (employee.full_name) {
    return employee.full_name;
  }

  if (employee.employee_name) {
    return employee.employee_name;
  }

  return `${employee.firstName || ""} ${
    employee.lastName || ""
  }`.trim();
};

const getCustomerName = (customer) => {
  if (!customer) {
    return "";
  }

  return customer.customerName || customer.name || "";
};

const formatDisplayDate = (date) => {
  if (!date) {
    return "-";
  }

  const parsedDate = new Date(date);

  if (Number.isNaN(parsedDate.getTime())) {
    return "-";
  }

  return parsedDate.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const formatDateForInput = (date) => {
  if (!date) {
    return new Date().toISOString().split("T")[0];
  }

  if (typeof date === "string" && date.length >= 10) {
    return date.substring(0, 10);
  }

  return new Date(date).toISOString().split("T")[0];
};

const getStatusColor = (status) => {
  switch (status) {
    case "Pending":
      return "warning";

    case "Complete":
      return "info";

    case "Delivered":
      return "success";

    case "Collected":
      return "success";

    default:
      return "default";
  }
};

const RepairJob = () => {
  const [jobs, setJobs] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [employees, setEmployees] = useState([]);
  const companyIN = useSelector((state) => state.loginReducer.vat);
  // console.log(companyIN,"companyIN")
  const [form, setForm] = useState(initialForm);
  const [filters, setFilters] = useState(initialFilters);
  const [appliedFilters, setAppliedFilters] =
    useState(initialFilters);

  const [loading, setLoading] = useState(false);
  const [customerLoading, setCustomerLoading] =
    useState(false);
  const [employeeLoading, setEmployeeLoading] =
    useState(false);
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const [openJobModal, setOpenJobModal] =
    useState(false);
  const [openDeleteModal, setOpenDeleteModal] =
    useState(false);

  const [selectedJob, setSelectedJob] =
    useState(null);
  const [jobToDelete, setJobToDelete] =
    useState(null);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] =
    useState(20);
  const [totalRecords, setTotalRecords] =
    useState(0);
const dispatch = useDispatch()
  const [message, setMessage] = useState({
    open: false,
    text: "",
    severity: "success",
  });

  const [paymentDialogOpen, setPaymentDialogOpen] = useState(false);
const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
const [selectedJobId, setSelectedJobId] = useState(null);
const [selectedJobOn, setSelectedJobOn] = useState(null);
const [statusUpdating, setStatusUpdating] = useState(false);
const navigation = useNavigate()

  const showMessage = (
    text,
    severity = "success"
  ) => {
    setMessage({
      open: true,
      text,
      severity,
    });
  };

  //print
//   const escapePrintValue = (value) => {
//   const characters = {
//     "&": "&amp;",
//     "<": "&lt;",
//     ">": "&gt;",
//     '"': "&quot;",
//     "'": "&#039;",
//   };

//   return String(value ?? "-").replace(
//     /[&<>"']/g,
//     (character) => characters[character]
//   );
// };

// const getPrintCustomerName = (job) => {
//   return (
//     job.customerData?.customer_name ||
//     job.customerId?.customer_name ||
//     "-"
//   );
// };

// const getPrintDateTime = (job) => {
//   const rawDate = job.date || job.createdAt;

//   if (!rawDate) {
//     return new Date().toLocaleString("en-GB", {
//       day: "2-digit",
//       month: "2-digit",
//       year: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//       hour12: true,
//     });
//   }

//   const parsedDate = new Date(rawDate);

//   if (Number.isNaN(parsedDate.getTime())) {
//     return "-";
//   }

//   return parsedDate.toLocaleString("en-GB", {
//     day: "2-digit",
//     month: "2-digit",
//     year: "numeric",
//     hour: "2-digit",
//     minute: "2-digit",
//     hour12: true,
//   });
// };

// const openPrintWindow = (html, title) => {
//   const printWindow = window.open(
//     "",
//     "_blank",
//     "width=700,height=700"
//   );

//   if (!printWindow) {
//     alert(
//       "Print window was blocked. Please allow popups for this website."
//     );
//     return;
//   }

//   printWindow.document.open();
//   printWindow.document.write(`
//     <!DOCTYPE html>
//     <html>
//       <head>
//         <meta charset="UTF-8" />
//         <title>${escapePrintValue(title)}</title>
//       </head>

//       <body>
//         ${html}

//         <script>
//           window.onload = function () {
//             window.focus();

//             setTimeout(function () {
//               window.print();
//               window.close();
//             }, 300);
//           };
//         </script>
//       </body>
//     </html>
//   `);

//   printWindow.document.close();
// };

// const printCustomerReceipt = (job) => {
//   const customerName = escapePrintValue(
//     getPrintCustomerName(job)
//   );

//   const dateTime = escapePrintValue(
//     getPrintDateTime(job)
//   );

//   const jobNumber = escapePrintValue(
//     job.jobNo || "-"
//   );

//   const make = escapePrintValue(
//     job.phoneMake || "-"
//   );

//   const model = escapePrintValue(
//     job.phoneModel || "-"
//   );

//   const fault = escapePrintValue(
//     job.fault || "-"
//   );

//   const price = Number(job.price || 0).toFixed(2);

//   const receiptHtml = `
//     <style>
//       @page {
//         size: 80mm auto;
//         margin: 4mm;
//       }

//       * {
//         box-sizing: border-box;
//       }

//       html,
//       body {
//         margin: 0;
//         padding: 0;
//       }

//       body {
//         width: 72mm;
//         font-family: Arial, Helvetica, sans-serif;
//         color: #000;
//         font-size: 12px;
//       }

//       .receipt {
//         width: 100%;
//       }

//       .header {
//         text-align: center;
//         padding-bottom: 8px;
//         margin-bottom: 8px;
//         border-bottom: 1px dashed #000;
//       }

//       .header h1 {
//         font-size: 18px;
//         margin: 0 0 4px;
//       }

//       .header p {
//         margin: 0;
//         font-size: 11px;
//       }

//       .row {
//         display: flex;
//         justify-content: space-between;
//         align-items: flex-start;
//         gap: 8px;
//         margin-bottom: 7px;
//       }

//       .row-label {
//         font-weight: bold;
//         flex-shrink: 0;
//       }

//       .row-value {
//         text-align: right;
//         overflow-wrap: anywhere;
//       }

//       .fault-section {
//         margin-top: 8px;
//         padding: 8px 0;
//         border-top: 1px dashed #000;
//         border-bottom: 1px dashed #000;
//       }

//       .fault-title {
//         font-weight: bold;
//         margin-bottom: 4px;
//       }

//       .fault-value {
//         line-height: 1.4;
//         white-space: pre-wrap;
//         overflow-wrap: anywhere;
//       }

//       .price-row {
//         display: flex;
//         justify-content: space-between;
//         align-items: center;
//         margin-top: 10px;
//         font-size: 17px;
//         font-weight: bold;
//       }

//       .footer {
//         text-align: center;
//         margin-top: 14px;
//         padding-top: 8px;
//         border-top: 1px dashed #000;
//         font-size: 11px;
//       }
//     </style>

//     <div class="receipt">
//       <div class="header">
//         <h1>Repair Receipt</h1>
//         <p>Please keep this receipt for collection</p>
//       </div>

//       <div class="row">
//         <span class="row-label">Date/Time:</span>
//         <span class="row-value">${dateTime}</span>
//       </div>

//       <div class="row">
//         <span class="row-label">Job No:</span>
//         <span class="row-value">${jobNumber}</span>
//       </div>

//       <div class="row">
//         <span class="row-label">Customer:</span>
//         <span class="row-value">${customerName}</span>
//       </div>

//       <div class="row">
//         <span class="row-label">Make:</span>
//         <span class="row-value">${make}</span>
//       </div>

//       <div class="row">
//         <span class="row-label">Model:</span>
//         <span class="row-value">${model}</span>
//       </div>

//       <div class="fault-section">
//         <div class="fault-title">Reported Fault:</div>
//         <div class="fault-value">${fault}</div>
//       </div>

//       <div class="price-row">
//         <span>Price:</span>
//         <span>£${price}</span>
//       </div>

//       <div class="footer">
//         Thank you for choosing our repair service.
//       </div>
//     </div>
//   `;

//   openPrintWindow(
//     receiptHtml,
//     `Repair Receipt ${job.jobNo || ""}`
//   );
// };


const COMPANY_INFO = {
  name: companyIN?.nickName||companyIN?.companyName,
  addressLine1: companyIN?.companyAddress,
  addressLine2: companyIN?.city +", "+ companyIN?.postCode,
  phone: companyIN?.mobileNumber,
  vatNumber: companyIN?.vatNumber,
  footerMessage: "THANKS",
  terms: [
    "28 days warranty on all repairs.",
    "28 days warranty on brand new and used phones.",
    "14 days unwanted goods exchange or return and must be in original packing and not used with original receipt.",
  ],
};

const escapePrintValue = (value) => {
  return String(value ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
};

const getPrintCustomerName = (job) => {
  return (
    job?.customerData?.customer_name ||
    job?.customerName ||
    "Walk-in Customer"
  );
};

const getPrintDateTime = (job) => {
  const rawDate = job?.createdAt || job?.date || new Date();

  const date = new Date(rawDate);

  if (Number.isNaN(date.getTime())) {
    return "-";
  }

  return date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
};

const generateBarcodeSvg = (value) => {
  try {
    const svg = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "svg"
    );

    JsBarcode(svg, String(value), {
      format: "CODE128",
      width: 1.5,
      height: 45,
      margin: 0,
      displayValue: true,
      fontSize: 13,
      textMargin: 3,
      background: "#ffffff",
      lineColor: "#000000",
    });

    return new XMLSerializer().serializeToString(svg);
  } catch (error) {
    console.error("Barcode generation failed:", error);
    return "";
  }
};

const openPrintWindow = (receiptHtml, title = "Repair Receipt") => {
  const printWindow = window.open(
    "",
    "_blank",
    "width=420,height=750,top=50,left=50"
  );

  if (!printWindow) {
    alert("Please allow pop-ups to print the receipt.");
    return;
  }

  printWindow.document.open();

  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="UTF-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        />
        <title>${escapePrintValue(title)}</title>
      </head>

      <body>
        ${receiptHtml}

        <script>
          window.onload = function () {
            window.focus();

            setTimeout(function () {
              window.print();
            }, 300);
          };

          window.onafterprint = function () {
            window.close();
          };
        </script>
      </body>
    </html>
  `);

  printWindow.document.close();
};

const printCustomerReceipt = async (job) => {
  if (!job) {
    alert("Job information is missing.");
    return;
  }

  const companyName = escapePrintValue(COMPANY_INFO.name);
  const companyAddress1 = escapePrintValue(
    COMPANY_INFO.addressLine1
  );
  const companyAddress2 = escapePrintValue(
    COMPANY_INFO.addressLine2
  );
  const companyPhone = escapePrintValue(COMPANY_INFO.phone);
  const vatNumber = escapePrintValue(COMPANY_INFO.vatNumber);

  const customerName = escapePrintValue(
    getPrintCustomerName(job)
  );

  const customerAccount = escapePrintValue(
    job?.customerData?.accountNo || "-"
  );

  const dateTime = escapePrintValue(
    getPrintDateTime(job)
  );

  const jobNumber = escapePrintValue(
    job?.jobNo || "-"
  );

  const make = escapePrintValue(
    job?.phoneMake || "-"
  );

  const model = escapePrintValue(
    job?.phoneModel || "-"
  );

  const imei = escapePrintValue(
    job?.imei || "-"
  );

  const fault = escapePrintValue(
    job?.fault || "-"
  );

  const status = escapePrintValue(
    job?.status || "Pending"
  );

  const employeeName = escapePrintValue(
    job?.employeeData?.name || "-"
  );

  const priceNumber = Number(job?.price || 0);
  const price = priceNumber.toFixed(2);

  const barcodeValue =
    job?.jobNo || job?._id || Date.now().toString();

  const barcodeSvg = generateBarcodeSvg(barcodeValue);

  const termsHtml = COMPANY_INFO.terms
    .map(
      (term) =>
        `<div class="term-line">${escapePrintValue(term)}</div>`
    )
    .join("");
    const paidBy =
  job.status !== "Pending" && job.status !== "Complete"
    ? `
      <div class="paid-by" style="text-transform: capitalize;">
        Paid By: ${job?.paymentMethod || "-"}
      </div>
    `
    : `<div class="paid-by" style="text-transform: capitalize;">
        To Pay
      </div>`;
    const paidBytemplate = `
  <div class="job-details">
    ${paidBy}
  </div>
`;

  const receiptHtml = `
    <style>
      @page {
        size: 80mm auto;
        margin: 0;
      }

      * {
        box-sizing: border-box;
      }

      html,
      body {
        width: 80mm;
        margin: 0;
        padding: 0;
        background: #ffffff;
        color: #000000;
      }

      body {
       font-family: Arial, Helvetica, sans-serif;
        font-size: 12px;
        font-weight: 600;
        line-height: 1.25;
        color: #000000;
      }

      .receipt {
        width: 80mm;
        min-height: 100mm;
        padding: 4mm;
        overflow: hidden;
      }

      .center {
        text-align: center;
      }

      .company-name {
        margin: 0 0 8px;
        font-size: 18px;
        font-weight: 700;
        text-transform: uppercase;
        color: #000000;
      }

      .company-details {
        font-size: 14px;
        line-height: 1.3;
        color: #000000;
      }

      .company-details div {
        margin: 1px 0;
      }

      .separator {
        width: 100%;
        margin: 8px 0 5px;
        overflow: hidden;
        white-space: nowrap;
        font-weight: 700;
        letter-spacing: -0.2px;
      }

      .separator::before {
        content: "============================================";
      }

      .separator.dashed::before {
        content: "--------------------------------------------";
      }

      .table-header,
      .item-total-row {
        display: grid;
        grid-template-columns: minmax(0, 1fr) 28px 48px 48px;
        gap: 2px;
        width: 100%;
      }

      .table-header {
        font-weight: 700;
        margin: 2px 0;
      }

      .table-header span:nth-child(n + 2),
      .item-total-row span:nth-child(n + 2) {
        text-align: right;
      }

      .job-section {
        margin-top: 8px;
      }

      .info-line {
        display: grid;
        grid-template-columns: 82px minmax(0, 1fr);
        gap: 3px;
        margin: 2px 0;
        align-items: start;
      }

      .info-label {
        white-space: nowrap;
        color: #000000;
      }

      .info-value {
        overflow-wrap: anywhere;
        word-break: break-word;
        color: #000000;
      }

      .fault-line {
        margin-top: 2px;
      }

      .fault-value {
        margin-top: 2px;
        white-space: pre-wrap;
        overflow-wrap: anywhere;
        word-break: break-word;
        color: #000000;
      }

      .item-description {
        margin-top: 5px;
        padding-left: 2px;
        overflow-wrap: anywhere;
        color: #000000;
      }

      .item-total-row {
        margin-top: 5px;
      }

      .totals {
        width: 100%;
        margin-top: 4px;
        padding-left: 35%;
        color: #000000;
      }

      .total-row {
        display: grid;
        grid-template-columns: minmax(0, 1fr) 60px;
        gap: 5px;
        margin: 2px 0;
        color: #000000;
      }

      .total-row span:last-child {
        text-align: right;
      }

      .paid-by {
        text-align: center;
        margin-top: 7px;
        font-weight: 700;
        font-size: 14px;
        color: #000000;
      }

      .service-info {
        margin-top: 10px;
      }

      .terms {
        margin-top: 10px;
        font-size: 12.5px;
        line-height: 1.3;
        color: #000000;
      }

      .term-line {
        margin-bottom: 2px;
      }

      .barcode {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 14px auto 8px;
        width: 100%;
        overflow: hidden;
      }

      .barcode svg {
        display: block;
        max-width: 62mm;
        height: auto;
      }

      .footer-message {
        margin-top: 12px;
        text-align: center;
        font-size: 13px;
        font-weight: 700;
        color: #000000;
      }

      @media print {
        html,
        body {
          width: 80mm !important;
          margin: 0 !important;
          padding: 0 !important;
        }

        .receipt {
          width: 80mm !important;
          padding: 4mm !important;
        }
      }
    </style>

    <div class="receipt">
      <header class="center">
        <h1 class="company-name">${companyName}</h1>

        <div class="company-details">
          <div>${companyAddress1}</div>
          <div>${companyAddress2}</div>
          <div>Tel: ${companyPhone}</div>
          <div>VAT: ${vatNumber}</div>
        </div>
      </header>

      <div class="separator"></div>

      <div class="table-header">
        <span>ITEM</span>
        <span>QTY</span>
        <span>PRICE</span>
        <span>VALUE</span>
      </div>

      <div class="separator dashed"></div>

      <section class="job-section">
        <div class="info-line">
          <span class="info-label">Repair Job:</span>
          <span class="info-value">${make} ${model}</span>
        </div>

        <div class="info-line">
          <span class="info-label">Job ID:</span>
          <span class="info-value">${jobNumber}</span>
        </div>

        <div class="info-line">
          <span class="info-label">Customer:</span>
          <span class="info-value">${customerName}</span>
        </div>

        <div class="info-line">
          <span class="info-label">Account No:</span>
          <span class="info-value">${customerAccount}</span>
        </div>

        <div class="info-line">
          <span class="info-label">Make:</span>
          <span class="info-value">${make}</span>
        </div>

        <div class="info-line">
          <span class="info-label">Model:</span>
          <span class="info-value">${model}</span>
        </div>

        <div class="info-line">
          <span class="info-label">IMEI:</span>
          <span class="info-value">${imei}</span>
        </div>

        <div class="info-line">
          <span class="info-label">Status:</span>
          <span class="info-value">${status}</span>
        </div>

        <div class="fault-line">
          <span>Fault:</span>
          <div class="fault-value">${fault}</div>
        </div>

        <div class="item-description">
          ${make} ${model} repair service
        </div>

        <div class="item-total-row">
          <span></span>
          <span>1</span>
          <span>${price}</span>
          <span>${price}</span>
        </div>
      </section>

      <div class="separator dashed"></div>

      <section class="totals">
        <div class="total-row">
          <span>Totals: 1</span>
          <span>£${price}</span>
        </div>

        <div class="total-row">
          <span>Tendered:</span>
          <span>£${price}</span>
        </div>

        <div class="total-row">
          <span>Change Given:</span>
          <span>£0.00</span>
        </div>
      </section>

      <div class="separator dashed"></div>

      ${paidBytemplate}

      <section class="service-info">
        <div class="info-line">
          <span class="info-label">Served By:</span>
          <span class="info-value">${employeeName}</span>
        </div>

        <div class="info-line">
          <span class="info-label">Job No:</span>
          <span class="info-value">${jobNumber}</span>
        </div>

        <div class="info-line">
          <span class="info-label">Date Time:</span>
          <span class="info-value">${dateTime}</span>
        </div>
      </section>

      <section class="terms">
        ${termsHtml}
      </section>

      ${
        barcodeSvg
          ? `<div class="barcode">${barcodeSvg}</div>`
          : ""
      }

      <div class="footer-message">
        ${escapePrintValue(COMPANY_INFO.footerMessage)}
      </div>
    </div>
  `;

  openPrintWindow(
    receiptHtml,
    `Repair Receipt ${job?.jobNo || ""}`
  );
  const tillResult =
    await window.electronAPI.openTill();

  console.log(
    "Till result:",
    tillResult
  );
};

const LABEL_CONFIG = {
  width: 60,  // millimetres
  height: 40, // millimetres
  companyName: "Mobile Technicians Falkirk",
};

const formatLabelDateTime = (value) => {
  if (!value) return "-";

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return "-";
  }

  return date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
};

const formatPickupDateTime = (value) => {
  if (!value) return "-";

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return "-";
  }

  return date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
};

const generateBarcodeSvg2 = (value) => {
  try {
    const svg = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "svg"
    );

    JsBarcode(svg, String(value), {
      format: "CODE128",

      // Barcode thickness
      width: 1.5,

      // Internal SVG height
      height: 45,

      // We don't need number below barcode
      displayValue: false,

      // Very important
      margin: 0,

      background: "#ffffff",
      lineColor: "#000000"
    });

    return svg.outerHTML;
  } catch (error) {
    console.error("Barcode generation failed:", error);
    return "";
  }
};
const printPhoneLabel = (job) => {
  if (!job) {
    alert("Job information is missing.");
    return;
  }

  const customerName = escapePrintValue(
    getPrintCustomerName(job)
  );

  const jobNumber = escapePrintValue(
    job?.jobNo || "-"
  );

  const bookedDate = escapePrintValue(
    formatLabelDateTime(
      job?.createdAt || job?.date
    )
  );

  const pickupDate = escapePrintValue(
    formatPickupDateTime(
      job?.pickupDate ||
        job?.collectionDate ||
        job?.deliveryDate
    )
  );

  const fault = escapePrintValue(
    job?.fault || "-"
  );

  const contact = escapePrintValue(
    job?.customerData?.phoneNumber ||
      job?.customerData?.phone ||
      job?.customerData?.mobile ||
      job?.customerPhone ||
      "-"
  );

  const make = escapePrintValue(
    job?.phoneMake || "-"
  );

  const model = escapePrintValue(
    job?.phoneModel || "-"
  );

  const companyName = escapePrintValue(
    LABEL_CONFIG.companyName || ""
  );

  const isUrgent =
    job?.urgent === true ||
    String(job?.priority || "").toLowerCase() === "urgent";

  const barcodeValue =
    job?.jobNo ||
    job?._id ||
    Date.now().toString();

  const barcodeSvg = generateBarcodeSvg2(barcodeValue);

  const labelHtml = `
    <style>
      @page {
        size: ${LABEL_CONFIG.width}mm ${LABEL_CONFIG.height}mm;
        margin: 0;
      }

      * {
        box-sizing: border-box;
      }

      html,
      body {
        width: ${LABEL_CONFIG.width}mm;
        height: ${LABEL_CONFIG.height}mm;

        margin: 0 !important;
        padding: 0 !important;

        overflow: hidden;

        background: #ffffff !important;
        color: #000000 !important;

        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
      }

      body {
        font-family: Arial, Helvetica, sans-serif;

        font-size: 10px;
        font-weight: 700;

        line-height: 1.08;

        color: #000000 !important;

        -webkit-font-smoothing: none;
        text-rendering: geometricPrecision;
      }

      .phone-label {
        position: relative;

        width: ${LABEL_CONFIG.width}mm;
        height: ${LABEL_CONFIG.height}mm;

        padding:
          1.7mm
          1.8mm
          1.4mm
          1.8mm;

        overflow: hidden;

        background: #ffffff;
        color: #000000;
      }

      /* ==========================================
         INFORMATION SECTION
      ========================================== */

      .information {
        width: 100%;

        padding-bottom: 9mm;

        color: #000;
      }

      .field-row {
        display: grid;

        grid-template-columns:
          12.5mm
          minmax(0, 1fr);

        column-gap: 0.8mm;

        align-items: start;

        width: 100%;

        margin: 0 0 0.65mm 0;

        color: #000000;
      }

      .field-label {
        font-size: 9.5px;
        font-weight: 800;

        white-space: nowrap;

        color: #000000 !important;
      }

      .field-value {
        min-width: 0;

        font-size: 10px;
        font-weight: 700;

        color: #000000 !important;

        overflow-wrap: anywhere;
        word-break: break-word;
      }

      /* ==========================================
         JOB NUMBER
      ========================================== */

      .job-value {
        font-size: 10.5px;
        font-weight: 900;

        color: #000000 !important;
      }

      /* ==========================================
         BOOKED + URGENT
      ========================================== */

      .booking-value {
        display: flex;

        align-items: center;

        flex-wrap: nowrap;

        gap: 1.2mm;

        color: #000000;
      }

      .booked-date {
        white-space: nowrap;
      }

      .urgent {
        display: inline-flex;

        align-items: center;

        gap: 0.7mm;

        white-space: nowrap;

        font-size: 9px;
        font-weight: 800;

        color: #000000 !important;
      }

      .checkbox {
        display: inline-flex;

        width: 3.2mm;
        height: 3.2mm;

        border: 0.45mm solid #000000;

        align-items: center;
        justify-content: center;

        font-family: Arial, Helvetica, sans-serif;

        font-size: 10px;
        font-weight: 900;

        line-height: 1;

        color: #000000;
      }

      /* ==========================================
         FAULT
      ========================================== */

      .fault-row {
        margin-top: 0.2mm;
      }

      .fault-value {
        max-height: 6.5mm;

        line-height: 1.05;

        overflow: hidden;

        font-size: 9.5px;
        font-weight: 700;

        color: #000000 !important;
      }

      /* ==========================================
         BOTTOM
      ========================================== */

      .bottom-section {
        position: absolute;

        left: 1.8mm;
        right: 1.8mm;
        bottom: 1.2mm;

        height: 7.5mm;

        display: flex;

        align-items: flex-end;
        justify-content: space-between;

        gap: 2mm;

        color: #000000;
      }

      /* ==========================================
         BARCODE
      ========================================== */

      .barcode {
  width: 27mm;
  height: 8mm;

  display: flex;
  align-items: flex-end;
  justify-content: flex-start;

  overflow: hidden;
  background: #ffffff;
}

.barcode svg {
  display: block;

  width: 27mm !important;
  height: 8mm !important;

  max-width: 27mm;

  shape-rendering: crispEdges;

  background: #ffffff;
}

      /* ==========================================
         COMPANY
      ========================================== */

      .company-name {
        flex: 1;

        max-width: 28mm;

        padding-bottom: 0.2mm;

        text-align: right;

        font-family: Arial, Helvetica, sans-serif;

        font-size: 9px;
        font-weight: 900;

        line-height: 1.05;

        color: #000000 !important;

        overflow-wrap: anywhere;
      }

      /* ==========================================
         PRINT
      ========================================== */

      @media print {
        html,
        body,
        .phone-label {
          width: ${LABEL_CONFIG.width}mm !important;
          height: ${LABEL_CONFIG.height}mm !important;

          margin: 0 !important;
          padding-left: 0;
        }

        body {
          color: #000000 !important;
          background: #ffffff !important;
        }
      }
    </style>

    <div class="phone-label">

      <div class="information">

        <!-- JOB -->
        <div class="field-row">
          <div class="field-label">
            Job No:
          </div>

          <div class="field-value job-value">
            ${jobNumber} - ${customerName}
          </div>
        </div>


        <!-- BOOKED -->
        <div class="field-row">
          <div class="field-label">
            Booked:
          </div>

          <div class="field-value booking-value">

            <span class="booked-date">
              ${bookedDate}
            </span>

            <span class="urgent">
              Urgent

              <span class="checkbox">
                ${isUrgent ? "X" : ""}
              </span>
            </span>

          </div>
        </div>


        <!-- PICKUP -->
        <div class="field-row">
          <div class="field-label">
            Pick up:
          </div>

          <div class="field-value">
            ${pickupDate}
          </div>
        </div>


        <!-- FAULT -->
        <div class="field-row fault-row">
          <div class="field-label">
            Fault:
          </div>

          <div class="field-value fault-value">
            ${make} ${model} - ${fault}
          </div>
        </div>


        <!-- CONTACT -->
        <div class="field-row">
          <div class="field-label">
            Contact:
          </div>

          <div class="field-value">
            ${contact}
          </div>
        </div>

      </div>


      <!-- BOTTOM -->
      <div class="bottom-section">

        ${
          barcodeSvg
            ? `<div class="barcode">${barcodeSvg}</div>`
            : `<div class="barcode"></div>`
        }

        <div class="company-name">
          ${companyName}
        </div>

      </div>

    </div>
  `;

  openPrintWindow(
    labelHtml,
    `Phone Label ${job?.jobNo || ""}`
  );
};

  //print -- end

  const fetchCustomers = useCallback(async () => {
    try {
      setCustomerLoading(true);

      let data = sessionStorage.getItem("userData");
      data = JSON.parse(data);
      let token = data;
      const response = await axios.get(
        `${Base_Uri}getCustomers`,
        {headers:{Authorization:`Bearer ${token}`},
          params: {
            page: 1,
            limit: 1000,
          },
        },
        
      );

      setCustomers(getArrayFromResponse(response));
    } catch (error) {
      console.error("Customer fetch error:", error);

      showMessage(
        error?.response?.data?.message ||
          "Unable to fetch customers.",
        "error"
      );
    } finally {
      setCustomerLoading(false);
    }
  }, []);

  const fetchEmployees = useCallback(async () => {
    try {
      setEmployeeLoading(true);

      let data = sessionStorage.getItem("userData");
      data = JSON.parse(data);
      let token = data;
      const response = await axios.get(
        `${Base_Uri}getAllEmployees`,
        {headers:{Authorization:`Bearer ${token}`},
          params: {
            page: 1,
            limit: 1000,
          },
        }
      );

      setEmployees(getArrayFromResponse(response));
    } catch (error) {
      console.error("Employee fetch error:", error);

      showMessage(
        error?.response?.data?.message ||
          "Unable to fetch employees.",
        "error"
      );
    } finally {
      setEmployeeLoading(false);
    }
  }, []);

  const fetchRepairJobs = useCallback(async () => {
    try {
      setLoading(true);

      const params = {
        page: page + 1,
        limit: rowsPerPage,
      };

      Object.keys(appliedFilters).forEach((key) => {
        const value = appliedFilters[key];

        if (
          value !== "" &&
          value !== null &&
          value !== undefined
        ) {
          params[key] = value;
        }
      });
      let data = sessionStorage.getItem("userData");
      data = JSON.parse(data);
      let token = data;

      const response = await axios.get(
        `${Base_Uri}repair-jobs`,
        {headers:{Authorization:`Bearer ${token}`},
          params,
        }
      );

      const records = getArrayFromResponse(response);

      setJobs(records);

      setTotalRecords(
        response?.data?.pagination?.totalRecords ||
          response?.data?.totalRecords ||
          records.length
      );
    } catch (error) {
      console.error("Repair jobs fetch error:", error);

      setJobs([]);
      setTotalRecords(0);

      showMessage(
        error?.response?.data?.message ||
          "Unable to fetch repair jobs.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  }, [page, rowsPerPage, appliedFilters]);

  useEffect(() => {
    fetchCustomers();
    fetchEmployees();
  }, [fetchCustomers, fetchEmployees]);

  useEffect(() => {
    fetchRepairJobs();
  }, [fetchRepairJobs]);

  const handleFormChange = (event) => {
    const { name, value } = event.target;

    setForm((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  const handleFilterChange = (event) => {
    const { name, value } = event.target;

    setFilters((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  const openCreateJobModal = () => {
    setSelectedJob(null);
    setForm(initialForm);
    setOpenJobModal(true);
  };

  const openEditJobModal = (job) => {
    setSelectedJob(job);

    setForm({
      customerId:
        job.customerId?._id ||
        job.customerId ||
        "",
      employeeId:
        job.employeeId?._id ||
        job.employeeId ||
        "",
      phoneMake: job.phoneMake || "",
      phoneModel: job.phoneModel || "",
      imei: job.imei || "",
      fault: job.fault || "",
      advancedPrice: job.advancedPrice !== undefined &&
        job.advancedPrice !== null?String(job.advancedPrice):"",
      price:
        job.price !== undefined &&
        job.price !== null
          ? String(job.price)
          : "",
      date: formatDateForInput(job.date),
      status: job.status || "Pending",
    });

    setOpenJobModal(true);
  };

  const closeJobModal = () => {
    if (saving) {
      return;
    }

    setOpenJobModal(false);
    setSelectedJob(null);
    setForm(initialForm);
  };

  const validateForm = () => {
    if (!form.customerId) {
      showMessage(
        "Please select a customer.",
        "error"
      );

      return false;
    }

    // if (!form.employeeId) {
    //   showMessage(
    //     "Please select an employee.",
    //     "error"
    //   );

    //   return false;
    // }

    if (!form.phoneMake.trim()) {
      showMessage(
        "Phone make is required.",
        "error"
      );

      return false;
    }

    if (!form.phoneModel.trim()) {
      showMessage(
        "Phone model is required.",
        "error"
      );

      return false;
    }

    if (!form.imei.trim()) {
      showMessage("IMEI is required.", "error");

      return false;
    }

    if (!form.fault.trim()) {
      showMessage(
        "Fault description is required.",
        "error"
      );

      return false;
    }

    if (
      form.price === "" ||
      Number.isNaN(Number(form.price)) ||
      Number(form.price) < 0
    ) {
      showMessage(
        "Please enter a valid price.",
        "error"
      );

      return false;
    }

    return true;
  };

  const OnClickAddtoSale = async()=>{
     let data = await sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;
    try {
      let getCustomer = await axios.get(`${Base_Uri}getCustomers?id=${selectedJobOn?.customerId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        })
        console.log(selectedJobOn?.products?.map((e)=>e?._id)?.join(","),"selectedJobOn?.products?.map((e)=>e?._id)?.join(",")")
      let getProducts =  selectedJobOn?.products&&selectedJobOn?.products?.length!=0?await axios.get(`${Base_Uri}getProducts?ids=${selectedJobOn?.products?.map((e)=>e?.productId)?.join(",")}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }):[]
    console.log(getCustomer?.data?.data,getProducts?.data?.data,"p")

    let normalizeProduct = getProducts?.data?.data?.map((e)=>({...e,saleQty:selectedJobOn?.products?.find((j)=>j.productId==e?._id)?.qty}))
  let normalizedCustomer = getCustomer?.data?.data

  dispatch(updateCart(normalizeProduct))
  dispatch(selectInvoicedCustomer(normalizedCustomer?.[0]))
  dispatch(UpdateJobDetails({jobId:selectedJobOn?._id,jobNo:selectedJobOn?.jobNo,productDetails:selectedJobOn?.products&&selectedJobOn?.products?.length!=0?selectedJobOn?.products?.map((e)=>({productId:e?.productId,qty:e?.qty,barcode:e?.productData?.barcode,totalPrice:e?.totalPrice})):[]}))
  setPaymentDialogOpen(false)
  navigation("/PointOfSale")
  } catch (error) {
      
    }
  }

  const handleStatusChange = (jobId, newStatus,job) => {
  if (newStatus === "Collected") {
    setSelectedJobId(jobId);
    setSelectedJobOn(job);
    setSelectedPaymentMethod("");
    setPaymentDialogOpen(true);
    console.log(job,"job")
    return;
  }

  handleStatusUpdate(jobId, newStatus);
};

const handleClosePaymentDialog = () => {
  if (statusUpdating) return;

  setPaymentDialogOpen(false);
  setSelectedPaymentMethod("");
  setSelectedJobId(null);
  setSelectedJobOn(null);

};

const handleConfirmCollected = async () => {
  if (!selectedPaymentMethod) {
    showMessage(
  "Please select a payment method.",
  "error"
);

    return;
  }

  try {
    setStatusUpdating(true);

    await handleStatusUpdate(
      selectedJobId,
      "Collected",
      selectedPaymentMethod
    );

    setPaymentDialogOpen(false);
    setSelectedPaymentMethod("");
    setSelectedJobId(null);
    setSelectedJobOn(null);
  } catch (error) {
    console.error("Collection status update failed:", error);
  } finally {
    setStatusUpdating(false);
  }
};

  const handleSaveJob = async () => {
    if (!validateForm()) {
      return;
    }

    try {
      setSaving(true);

      const payload = {
        customerId: form.customerId,
        // employeeId: form.employeeId,
        phoneMake: form.phoneMake.trim(),
        phoneModel: form.phoneModel.trim(),
        imei: form.imei.trim(),
        fault: form.fault.trim(),
        price: Number(form.price),
        advancedPrice: Number(form.advancedPrice||0),
        date: form.date,
        status: form.status,
      };
      let data = sessionStorage.getItem("userData");
      data = JSON.parse(data);
      let token = data;

      if (selectedJob?._id) {
        await axios.patch(
          `${Base_Uri}repair-jobs/${selectedJob._id}`,
          payload,{headers:{Authorization:`Bearer ${token}`},}
        );

        showMessage(
          "Repair job updated successfully."
        );
      } else {
        await axios.post(
          `${Base_Uri}repair-jobs`,
          payload,{headers:{Authorization:`Bearer ${token}`},}
        );

        showMessage(
          "Repair job created successfully."
        );
      }

      closeJobModal();
      fetchRepairJobs();
    } catch (error) {
      console.error("Repair job save error:", error);

      showMessage(
        error?.response?.data?.message ||
          "Unable to save repair job.",
        "error"
      );
    } finally {
      setSaving(false);
    }
  };

 const handleStatusUpdate = async (
  jobId,
  status,
  paymentMethod = null
) => {
  try {
    const storedUserData = sessionStorage.getItem("userData");
    const token = JSON.parse(storedUserData);

    const requestBody = {
      status,
    };

    if (status === "Collected") {
      if (!paymentMethod) {
        showMessage(
          "Please select a payment method.",
          "error"
        );
        return;
      }

      requestBody.payment_method = paymentMethod;
      requestBody.collected_at = new Date().toISOString();
    }

    // Optimistically update the table
    setJobs((previousJobs) =>
      previousJobs.map((job) =>
        job._id === jobId
          ? {
              ...job,
              status,
              ...(status === "Collected" && {
                payment_method: paymentMethod,
                collected_at: requestBody.collected_at,
              }),
            }
          : job
      )
    );

    await axios.patch(
      `${Base_Uri}repair-jobs/${jobId}/status`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    showMessage(
      status === "Collected"
        ? "Repair job collected successfully."
        : "Repair job status updated successfully."
    );
  } catch (error) {
    console.error("Status update error:", error);

    showMessage(
      error?.response?.data?.message ||
        "Unable to update status.",
      "error"
    );

    // Restore latest data if API update fails
    fetchRepairJobs();
  }
};

  const openDeleteConfirmation = (job) => {
    setJobToDelete(job);
    setOpenDeleteModal(true);
  };

  const closeDeleteConfirmation = () => {
    if (deleting) {
      return;
    }

    setOpenDeleteModal(false);
    setJobToDelete(null);
  };

  const handleDeleteJob = async () => {
    if (!jobToDelete?._id) {
      return;
    }

    try {
      setDeleting(true);
let data = sessionStorage.getItem("userData");
      data = JSON.parse(data);
      let token = data;
      await axios.delete(
        `${Base_Uri}repair-jobs/${jobToDelete._id}`,
        {headers:{Authorization:`Bearer ${token}`},}
      );

      showMessage(
        "Repair job deleted successfully."
      );

      closeDeleteConfirmation();

      if (jobs.length === 1 && page > 0) {
        setPage((previous) => previous - 1);
      } else {
        fetchRepairJobs();
      }
    } catch (error) {
      console.error("Repair job delete error:", error);

      showMessage(
        error?.response?.data?.message ||
          "Unable to delete repair job.",
        "error"
      );
    } finally {
      setDeleting(false);
    }
  };

  const handleApplyFilters = () => {
    setPage(0);
    setAppliedFilters(filters);
  };

  const handleResetFilters = () => {
    setFilters(initialFilters);
    setAppliedFilters(initialFilters);
    setPage(0);
  };

  const handlePageChange = (
    event,
    newPage
  ) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(
      parseInt(event.target.value, 10)
    );

    setPage(0);
  };

  const selectedCustomer =
    customers.find(
      (customer) =>
        String(customer.id) ===
        String(form.customerId)
    ) || null;
    const userData = useSelector((state) => state.loginReducer.updatedState);
    
  // const selectedEmployee =
  //   employees.find(
  //     (employee) =>
  //       String(employee._id) ===
  //       String(form.employeeId)
  //   ) || null;

  return (
    <Box
      sx={{
        minHeight: "100vh",
        color: Colors.black,
        backgroundColor: Colors.main,
      }}
    >
      <Navbar currentPage="Repair Jobs" />

      <Grid
        container
        spacing={2}
        sx={{
          padding: {
            xs: "15px",
            md: "20px",
            lg: "20px 30px",
          },
        }}
      >
        <Grid item xs={12}>
          <Paper
            elevation={0}
            sx={{
              padding: {
                xs: 2,
                md: 2.5,
              },
              borderRadius: 3,
              border: "1px solid #e8e8e8",
            }}
          >
            <Stack
              direction={{
                xs: "column",
                sm: "row",
              }}
              justifyContent="space-between"
              alignItems={{
                xs: "stretch",
                sm: "center",
              }}
              spacing={2}
            >
              <Box>
                <Typography
                  variant="h5"
                  fontWeight={700}
                >
                  Repair Jobs
                </Typography>

                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    marginTop: 0.5,
                  }}
                >
                  Create, track and manage customer
                  repair jobs.
                </Typography>
              </Box>

              <Stack direction="row" spacing={1}>
                <FaultyReportDialog />

                {((userData?.role_access?.length != 0 &&
                  userData.role_access?.some(
                    (role) =>
                      role?.subcategory &&
                      role?.subcategory?.some(
                        (sub) => sub.name === "Repair Jobs Create" && sub.selected
                      )
                  )) ||
                  userData.role == "admin")&&<Button
                  variant="contained"
                  startIcon={<Add />}
                  onClick={openCreateJobModal}
                  sx={{
                    minHeight: 44,
                    textTransform: "none",
                    borderRadius: 2,
                    fontWeight: 600,
                  }}
                >
                  Create New Job
                </Button>}
              </Stack>
            </Stack>
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Paper
            elevation={0}
            sx={{
              padding: 2,
              borderRadius: 3,
              border: "1px solid #e8e8e8",
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              spacing={1}
              sx={{
                marginBottom: 2,
              }}
            >
              <FilterAlt color="primary" />

              <Typography
                variant="h6"
                fontWeight={700}
              >
                Filters
              </Typography>
            </Stack>

            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                sm={6}
                md={3}
              >
                <TextField
                  fullWidth
                  size="small"
                  type="date"
                  label="Start Date"
                  name="startDate"
                  value={filters.startDate}
                  onChange={handleFilterChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>

              <Grid
                item
                xs={12}
                sm={6}
                md={3}
              >
                <TextField
                  fullWidth
                  size="small"
                  type="date"
                  label="End Date"
                  name="endDate"
                  value={filters.endDate}
                  onChange={handleFilterChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>

              <Grid
                item
                xs={12}
                sm={6}
                md={3}
              >
                <TextField
                  fullWidth
                  size="small"
                  label="Customer Name"
                  name="customerName"
                  value={filters.customerName}
                  onChange={handleFilterChange}
                  placeholder="Search customer"
                />
              </Grid>

              <Grid
                item
                xs={12}
                sm={6}
                md={3}
              >
                <TextField
                  fullWidth
                  size="small"
                  label="Account Number"
                  name="accountNo"
                  value={filters.accountNo}
                  onChange={handleFilterChange}
                  placeholder="Example: 1001"
                />
              </Grid>

              <Grid
                item
                xs={12}
                sm={6}
                md={3}
              >
                <TextField
                  fullWidth
                  size="small"
                  label="IMEI"
                  name="imei"
                  value={filters.imei}
                  onChange={handleFilterChange}
                  placeholder="Search IMEI"
                />
              </Grid>

              <Grid
                item
                xs={12}
                sm={6}
                md={3}
              >
                <TextField
                  fullWidth
                  size="small"
                  label="Job Number"
                  name="jobNo"
                  value={filters.jobNo}
                  onChange={handleFilterChange}
                  placeholder="JOB-000001"
                />
              </Grid>

              <Grid
                item
                xs={12}
                sm={6}
                md={3}
              >
                <FormControl
                  fullWidth
                  size="small"
                >
                  <InputLabel>Status</InputLabel>

                  <Select
                    label="Status"
                    name="status"
                    value={filters.status}
                    onChange={handleFilterChange}
                  >
                    <MenuItem value="">
                      All Statuses
                    </MenuItem>

                    {repairStatuses.map((status) => (
                      <MenuItem
                        key={status}
                        value={status}
                      >
                        {status}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid
                item
                xs={12}
                sm={6}
                md={3}
              >
                <Stack
                  direction="row"
                  spacing={1}
                >
                  <Button
                    fullWidth
                    variant="contained"
                    startIcon={<Search />}
                    onClick={handleApplyFilters}
                    sx={{
                      minHeight: 40,
                      textTransform: "none",
                    }}
                  >
                    Search
                  </Button>

                  <Tooltip title="Reset Filters">
                    <IconButton
                      onClick={handleResetFilters}
                      sx={{
                        border: "1px solid #dddddd",
                        borderRadius: 2,
                      }}
                    >
                      <Refresh />
                    </IconButton>
                  </Tooltip>
                </Stack>
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Paper
            elevation={0}
            sx={{
              borderRadius: 3,
              border: "1px solid #e8e8e8",
              overflow: "hidden",
            }}
          >
            <TableContainer>
              <Table
                sx={{
                  minWidth: 1400,
                }}
              >
                <TableHead>
                  <TableRow
                    sx={{
                      backgroundColor: "#f7f8fa",
                    }}
                  >
                    <TableCell>
                      <strong>Job No.</strong>
                    </TableCell>

                    <TableCell>
                      <strong>Date</strong>
                    </TableCell>

                    <TableCell>
                      <strong>Customer</strong>
                    </TableCell>

                    <TableCell>
                      <strong>Account No.</strong>
                    </TableCell>

                    <TableCell>
                      <strong>Phone</strong>
                    </TableCell>

                    <TableCell>
                      <strong>IMEI</strong>
                    </TableCell>

                    <TableCell>
                      <strong>Fault</strong>
                    </TableCell>

                    <TableCell>
                      <strong>Price</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Adv Pay</strong>
                    </TableCell>

                    <TableCell>
                      <strong>Employee</strong>
                    </TableCell>

                    <TableCell>
                      <strong>Status</strong>
                    </TableCell>

                    <TableCell align="center">
                      <strong>Actions</strong>
                    </TableCell>
                    <TableCell align="center">
                      <strong>Parts</strong>
                    </TableCell>

                    <TableCell align="center">
                      <strong>Faulty</strong>
                    </TableCell>

                    <TableCell>
                      <strong>Collected By</strong>
                    </TableCell>

                    <TableCell>
                      <strong>Collected At</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell
                        colSpan={15}
                        align="center"
                        sx={{
                          padding: 8,
                        }}
                      >
                        <CircularProgress size={35} />

                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{
                            marginTop: 1,
                          }}
                        >
                          Loading repair jobs...
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ) : jobs.length < 1 ? (
                    <TableRow>
                      <TableCell
                        colSpan={15}
                        align="center"
                        sx={{
                          padding: 8,
                        }}
                      >
                        <Typography
                          variant="h6"
                          fontWeight={600}
                        >
                          No repair jobs found
                        </Typography>

                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{
                            marginTop: 0.5,
                          }}
                        >
                          Create a new repair job or
                          change the selected filters.
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ) : (
                    jobs.map((job) => (
                      <TableRow
                        key={job._id}
                        hover
                      >
                        <TableCell>
                          <Typography
                            variant="body2"
                            fontWeight={700}
                            color="primary"
                          >
                            {job.jobNo || "-"}
                          </Typography>
                        </TableCell>

                        <TableCell>
                          {formatDisplayDate(job.date)}
                        </TableCell>

                        <TableCell>
                          <Box>
                            <Typography
                              variant="body2"
                              fontWeight={600}
                            >
                              {job.customerData
                                ?.customer_name ||
                                job.customerId
                                  ?.customer_name ||
                                "-"}
                            </Typography>

                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              {job.customerData
                                ?.business_name ||
                                job.customerId
                                  ?.business_name ||
                                ""}
                            </Typography>
                          </Box>
                        </TableCell>

                        <TableCell>
                          {job.customerData?.accountNo ||
                            job.customerId?.accountNo ||
                            "-"}
                        </TableCell>

                        <TableCell>
                          <Typography
                            variant="body2"
                            fontWeight={600}
                          >
                            {job.phoneMake || "-"}
                          </Typography>

                          <Typography
                            variant="caption"
                            color="text.secondary"
                          >
                            {job.phoneModel || "-"}
                          </Typography>
                        </TableCell>

                        <TableCell>
                          {job.imei || "-"}
                        </TableCell>

                        <TableCell
                          sx={{
                            maxWidth: 250,
                          }}
                        >
                          <Tooltip
                            title={job.fault || ""}
                          >
                            <Typography
                              variant="body2"
                              noWrap
                            >
                              {job.fault || "-"}
                            </Typography>
                          </Tooltip>
                        </TableCell>

                        <TableCell>
                          <Typography
                            variant="body2"
                            fontWeight={700}
                          >
                            £
                            {Number(
                              job.price || 0
                            ).toFixed(2)}
                          </Typography>
                        </TableCell>

                          <TableCell>
                          <Typography
                            variant="body2"
                            fontWeight={700}
                          >
                            £
                            {Number(
                              job?.advancedPrice || 0
                            ).toFixed(2)}
                          </Typography>
                        </TableCell>

                        <TableCell>
                          {job.employeeData?.name ||
                            getEmployeeName(
                              job.employeeId
                            ) ||
                            "-"}
                        </TableCell>

                        <TableCell>
  <FormControl
    size="small"
    sx={{
      minWidth: 135,
    }}
  >
    <Select
      value={job.status || "Pending"}
      disabled={
        !(
          (userData?.role_access?.length !== 0 &&
            userData.role_access?.some((role) =>
              role?.subcategory?.some(
                (sub) =>
                  sub.name ===
                    "Repair Jobs Status Update" &&
                  sub.selected
              )
            )) ||
          userData?.role === "admin"
        ) || !(
          (userData?.role_access?.length !== 0 &&
            userData.role_access?.some((role) =>
              role?.subcategory?.some(
                (sub) =>
                  sub.name ===
                    "Change Status After Collected" &&
                  sub.selected
              )
            )) ||
          userData?.role === "admin"
        )
      }
      onChange={(event) =>
        handleStatusChange(
          job._id,
          event.target.value,
          job
        )
      }
      renderValue={(value) => (
        <Chip
          size="small"
          label={value}
          color={getStatusColor(value)}
          sx={{
            fontWeight: 600,
          }}
        />
      )}
    >
      {repairStatuses.map((status) => (
        <MenuItem
          key={status}
          value={status}
        >
          {status}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</TableCell>

                        <TableCell align="center">
                          <Stack
                            direction="row"
                            justifyContent="center"
                            spacing={0.5}
                          >
                            {((userData?.role_access?.length != 0 &&
                userData.role_access?.some(
                  (role) =>
                    role?.subcategory &&
                    role?.subcategory?.some(
                      (sub) => sub.name === "Repair Jobs Edit" && sub.selected
                    )
                )) ||
                userData.role == "admin")&&(job?.status!="Collected"?<Tooltip title="Edit Job">
                              <IconButton
                                color="primary"
                                onClick={() =>
                                  openEditJobModal(job)
                                }
                              >
                                <Edit fontSize="small" />
                              </IconButton>
                            </Tooltip>:<></>)}

                            {((userData?.role_access?.length != 0 &&
                userData.role_access?.some(
                  (role) =>
                    role?.subcategory &&
                    role?.subcategory?.some(
                      (sub) => sub.name === "Repair Jobs Delete" && sub.selected
                    )
                )) ||
                userData.role == "admin")&&(<Tooltip title="Delete Job">
                              <IconButton
                                color="error"
                                onClick={() =>
                                  openDeleteConfirmation(
                                    job
                                  )
                                }
                              >
                                <Delete fontSize="small" />
                              </IconButton>
                            </Tooltip>)}
                          </Stack>
                          <Stack
  direction="row"
  justifyContent="center"
  spacing={0.5}
>
  <Tooltip title="Print Customer Receipt">
    <IconButton
      color="success"
      onClick={() => {printCustomerReceipt(job)
        console.log(job,"job")
      }}
    >
      <ReceiptLong fontSize="small" />
    </IconButton>
  </Tooltip>

  <Tooltip title="Print Phone Label">
    <IconButton
      color="secondary"
      onClick={() => printPhoneLabel(job)}
    >
      <LocalOffer fontSize="small" />
    </IconButton>
  </Tooltip>

  {/* Your existing Edit and Delete buttons */}
</Stack>
                        </TableCell>
<TableCell>
                          <ProductManager jobStatus={job?.status} jobId={job?._id} initialProducts={job?.products}  onSave={async payload => {
    let userData = sessionStorage.getItem("userData");
    userData = userData
      ? JSON.parse(userData)
      : null;

    const token = userData;

    const response = await axios.put(
      `${Base_Uri}repair-jobs/${job?._id}/products`,
      {
        productChanges: payload.productChanges,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    if (!response?.data?.success) {
      throw new Error(
        response?.data?.message ||
          "Unable to update products.",
      );
    }

    await fetchRepairJobs();
  }}/>
                        </TableCell>
                        <TableCell align="center">
                          <FaultyManager
                            job={job}
                            onChanged={fetchRepairJobs}
                          />
                        </TableCell>
                        <TableCell>
                          {job.collectedBy?.employeeId ||
                            "-"}
                        </TableCell>
                        <TableCell>
                          {(job?.collectedAt&&moment(job?.collectedAt).format("DD MMM, YYYY")) ||
                            "-"}
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              component="div"
              count={totalRecords}
              page={page}
              onPageChange={handlePageChange}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={
                handleRowsPerPageChange
              }
              rowsPerPageOptions={[10, 20, 50, 100]}
            />
          </Paper>
        </Grid>
      </Grid>

      <Dialog
  open={paymentDialogOpen}
  onClose={handleClosePaymentDialog}
  fullWidth
  maxWidth="xs"
>
  <DialogTitle>
    Select Payment Method
  </DialogTitle>

  <DialogContent dividers>
    <FormControl fullWidth>
      <FormLabel>
       <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
         <div>How did the customer pay?</div>
        <Button onClick={OnClickAddtoSale}>Add to Sale</Button>
       </div>
      </FormLabel>

      

      <RadioGroup
        value={selectedPaymentMethod}
        onChange={(event) =>
          setSelectedPaymentMethod(
            event.target.value
          )
        }
        sx={{
          mt: 1,
        }}
      >
        {paymentMethods.map((method) => (
          <FormControlLabel
            key={method.value}
            value={method.value}
            control={<Radio />}
            label={method.label}
          />
        ))}
      </RadioGroup>
    </FormControl>
  </DialogContent>

  <DialogActions>
    <Button
      onClick={handleClosePaymentDialog}
      disabled={statusUpdating}
      color="inherit"
    >
      Cancel
    </Button>

    <Button
      variant="contained"
      onClick={handleConfirmCollected}
      disabled={
        !selectedPaymentMethod ||
        statusUpdating
      }
    >
      {statusUpdating
        ? "Updating..."
        : "Confirm Collection"}
    </Button>
  </DialogActions>
</Dialog>

      <Dialog
        open={openJobModal}
        onClose={closeJobModal}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Typography
              variant="h6"
              fontWeight={700}
            >
              {selectedJob
                ? "Edit Repair Job"
                : "Create Repair Job"}
            </Typography>

            {!selectedJob && (
              <Typography
                variant="caption"
                color="text.secondary"
              >
                The job number will be created
                automatically.
              </Typography>
            )}
          </Box>

          <IconButton
            onClick={closeJobModal}
            disabled={saving}
          >
            <Close />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Autocomplete
                loading={customerLoading}
                options={customers}
                value={selectedCustomer}
                onChange={(event, newValue) => {
                  setForm((previous) => ({
                    ...previous,
                    customerId:
                      newValue?.id || "",
                  }));
                }}
                isOptionEqualToValue={(
                  option,
                  value
                ) =>
                  String(option.id) ===
                  String(value.id)
                }
                getOptionLabel={(option) => {
                  const customerName =
                    getCustomerName(option);
                  const accountNo =
                    option.accountNo || "";

                  return `${customerName}${
                    accountNo
                      ? ` - ${accountNo}`
                      : ""
                  }`;
                }}
                renderOption={(props, option) => (
                  <Box
                    component="li"
                    {...props}
                    key={option._id}
                  >
                    <Box>
                      <Typography
                        variant="body2"
                        fontWeight={600}
                      >
                        {getCustomerName(option)}
                      </Typography>

                      <Typography
                        variant="caption"
                        color="text.secondary"
                      >
                        {option.businessName || ""}
                        {option.businessName &&
                        option.accountNo
                          ? " • "
                          : ""}
                        {option.accountNo
                          ? `Account: ${option.accountNo}`
                          : ""}
                      </Typography>
                    </Box>
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    required
                    label="Select Customer"
                    placeholder="Search customer"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {customerLoading ? (
                            <CircularProgress
                              size={20}
                            />
                          ) : null}

                          {
                            params.InputProps
                              .endAdornment
                          }
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Grid>

            {/* <Grid item xs={12} md={6}>
              <Autocomplete
                loading={employeeLoading}
                options={employees}
                value={selectedEmployee}
                // disabled
                onChange={(event, newValue) => {
                  setForm((previous) => ({
                    ...previous,
                    employeeId:
                      newValue?._id || "",
                  }));
                }}
                isOptionEqualToValue={(
                  option,
                  value
                ) =>
                  String(option._id) ===
                  String(value._id)
                }
                getOptionLabel={(option) =>
                  getEmployeeName(option)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    required
                    label="Select Employee"
                    placeholder="Search employee"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {employeeLoading ? (
                            <CircularProgress
                              size={20}
                            />
                          ) : null}

                          {
                            params.InputProps
                              .endAdornment
                          }
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Grid> */}

            {selectedCustomer && (
              <Grid item xs={12}>
                <Paper
                  variant="outlined"
                  sx={{
                    padding: 1.5,
                    borderRadius: 2,
                    backgroundColor: "#fafafa",
                  }}
                >
                  <Grid container spacing={1}>
                    <Grid item xs={12} md={4}>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                      >
                        Customer Name
                      </Typography>

                      <Typography
                        variant="body2"
                        fontWeight={600}
                      >
                        {getCustomerName(
                          selectedCustomer
                        )}
                      </Typography>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                      >
                        Business Name
                      </Typography>

                      <Typography
                        variant="body2"
                        fontWeight={600}
                      >
                        {selectedCustomer.businessName ||
                          "-"}
                      </Typography>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                      >
                        Account Number
                      </Typography>

                      <Typography
                        variant="body2"
                        fontWeight={600}
                      >
                        {selectedCustomer.accountNo ||
                          "-"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            )}

            <Grid item xs={12} md={6}>
              <SearchableCreatableDropdown
                fullWidth
                required
                dropdownName="Phone_Make"
                label="Phone Make"
                name="phoneMake"
                value={form.phoneMake}
                onChange={handleFormChange}
                placeholder="Example: Apple"
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <SearchableCreatableDropdown
                fullWidth
                required
                dropdownName="Phone_Model"
                label="Phone Model"
                name="phoneModel"
                value={form.phoneModel}
                onChange={handleFormChange}
                placeholder="Example: iPhone 15 Pro"
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                label="IMEI"
                name="imei"
                value={form.imei}
                onChange={handleFormChange}
                placeholder="Enter IMEI number"
                inputProps={{
                  maxLength: 30,
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                type="number"
                label="Price"
                name="price"
                value={form.price}
                onChange={handleFormChange}
                placeholder="0.00"
                inputProps={{
                  min: 0,
                  step: "0.01",
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                // required
                type="number"
                label="Advance Pay"
                name="advancedPrice"
                value={form.advancedPrice}
                onChange={handleFormChange}
                placeholder="0.00"
                inputProps={{
                  min: 0,
                  step: "0.01",
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                type="date"
                label="Job Date"
                name="date"
                value={form.date}
                onChange={handleFormChange}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <FormControl fullWidth required>
                <InputLabel>Status</InputLabel>

                <Select
                  label="Status"
                  name="status"
                  value={form.status}
                  onChange={handleFormChange}
                  disabled={true}
                >
                  {repairStatuses.map((status) => (
                    <MenuItem
                      key={status}
                      value={status}
                    >
                      {status}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              {/* <TextField
                fullWidth
                required
                multiline
                minRows={4}
                label="Fault Description"
                name="fault"
                value={form.fault}
                onChange={handleFormChange}
                placeholder="Describe the phone fault and repair requirements"
              /> */}
              <SearchableCreatableDropdown fullWidth
                required
                multiline
                minRows={4}
                dropdownName="Fault_Description"
                label="Fault Description"
                name="fault"
                value={form.fault}
                onChange={handleFormChange}
                placeholder="Describe the phone fault and repair requirements" />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions
          sx={{
            padding: 2,
          }}
        >
          <Button
            onClick={closeJobModal}
            disabled={saving}
            sx={{
              textTransform: "none",
            }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={handleSaveJob}
            disabled={saving}
            sx={{
              minWidth: 130,
              textTransform: "none",
            }}
          >
            {saving ? (
              <CircularProgress
                size={23}
                color="inherit"
              />
            ) : selectedJob ? (
              "Update Job"
            ) : (
              "Create Job"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDeleteModal}
        onClose={closeDeleteConfirmation}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle>
          Delete Repair Job
        </DialogTitle>

        <DialogContent>
          <Typography>
            Are you sure you want to delete repair
            job{" "}
            <strong>
              {jobToDelete?.jobNo || ""}
            </strong>
            ?
          </Typography>

          <Typography
            variant="body2"
            color="error"
            sx={{
              marginTop: 1,
            }}
          >
            This action cannot be undone.
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={closeDeleteConfirmation}
            disabled={deleting}
            sx={{
              textTransform: "none",
            }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            color="error"
            onClick={handleDeleteJob}
            disabled={deleting}
            sx={{
              minWidth: 100,
              textTransform: "none",
            }}
          >
            {deleting ? (
              <CircularProgress
                size={22}
                color="inherit"
              />
            ) : (
              "Delete"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={message.open}
        autoHideDuration={4000}
        onClose={() =>
          setMessage((previous) => ({
            ...previous,
            open: false,
          }))
        }
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Alert
          severity={message.severity}
          variant="filled"
          onClose={() =>
            setMessage((previous) => ({
              ...previous,
              open: false,
            }))
          }
          sx={{
            width: "100%",
          }}
        >
          {message.text}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default RepairJob;